import { mapGetters } from 'vuex';

import { additionaloptions } from '@/febos/aduanas/batches/config/additional';

export default {
  computed: {
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('Usuario', ['currentUser'])
  },
  methods: {
    removeSemicolon(text, replace) {
      return (text || '').replace(/\;/g, (replace || '-'));
    },
    makeLine(tag, totalFields, values) {
      if (!values.length) return '';
      let camposVacios = true;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < values.length; i++) {
        if (values[i] !== '') {
          camposVacios = false;
        }
      }
      if (camposVacios) return '';
      let line = tag;
      // eslint-disable-next-line no-plusplus
      for (let field = 0; field < totalFields; field++) {
        line += ';';
        if (typeof values[field] === 'undefined') {
          // eslint-disable-next-line no-continue
          continue;
        }
        if (typeof values[field] === 'string') {
          line += this.removeSemicolon(values[field]).replace(/\r?\n/gm, '**');
        } else {
          line += values[field];
        }
      }
      line += line.replace(/\r?\n/gm, '**');
      line += '\n';
      return line;
    },
    getTaxInfo(code) {
      const foundedTax = additionaloptions.find((tax) => tax.id === code);
      return foundedTax.value || 'Sin Adicional';
    },

    async createIntegrationFile() {
      let integrationFile = '';
      integrationFile += this.makeLine('@TIPO_DOC', 1, ['Documento']);

      integrationFile += this.makeLine('@CABECERA', 17, [
        33,
        '',
        this.invoice.issueDate,
        '',
        '', // tipo de despacho
        '', // tipo de traslado
        '',
        '', // tipo de servicio
        '',
        '',
        '', // tipo de venta
        '2', // forma de pago
        '',
        '',
        '',
        this.$moment().add(1, 'month'),
        ''
      ]);

      integrationFile += this.makeLine('@EMISOR', 17, [
        this.company.iut,
        this.company.razonSocial,
        this.companyDataComplete.giro, // buscar el info de la empresa
        '', // telefono de la empresa
        '', // correo de la empresa
        '', // acteco de la empresa
        '',
        '',
        '',
        '', // direccion de la empresa
        '', // codigo sii
        '',
        '', // direccion
        '', // comuna
        '', // ciudad
        '', // nombre del vendedor
        ''
      ]);
      integrationFile += this.makeLine('@RECEPTOR', 16, [
        this.invoice.iut,
        '', // num id receptor
        this.invoice.businessName,
        '',
        '',
        '',
        '',
        this.invoice.commercialName, // giro de l receptor
        this.invoice.phone, // telefono
        this.invoice.email, // correo
        this.invoice.address, // direccion
        this.invoice.commune, // comuna
        this.invoice.city, // ciudad
        '',
        '',
        ''
      ]);

      integrationFile += this.makeLine('@TOTALES', 9, [
        '', // neto
        '', // exento
        '',
        '',
        '', // total
        '',
        '',
        '',
        ''
      ]);

      integrationFile += this.makeLine('@TOTAL_IMPUESTOS', 4, [
        '19', // validar si sera afecta, sino es ''
        '', // va el iva, sino es ''
        '',
        ''
      ]);
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.totals.additional.length; i++) {
        integrationFile += this.makeLine('@TOTAL_ADICIONALES', 3, [
          this.totals.additional[i].codigo,
          this.getTaxInfo(this.totals.additional[i].codigo),
          this.totals.additional[i].total
        ]);
      }
      for (let i = 0; i < this.mappedReceiptDataTable.length; i++) {
        integrationFile += this.makeLine('@DETALLE', 14, [
          i + 1,
          '', // tipo de codigo
          '', // codigo
          '', // tipo doc liquida ?
          '1', // <- creo que no es false por la condicion de febos indEx
          '', // nombre del detalle
          '', // descripcion del detalle
          '', // cantidad del detalle
          '',
          '',
          '', // unidad de medida
          '', // precio de detalle
          '', // si hay adicional ?
          '' // total detalle
        ]);
      }

      integrationFile += this.makeLine('@FEBOS_GLOBAL', 2,
        ['Monto Palabras', this.writeAmount]);

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.febosAdicional.length; i++) {
        integrationFile += this.makeLine('@FEBOS_GLOBAL', 2, [
          this.febosAdicional[i].nombre,
          this.febosAdicional[i].valor
        ]);
      }

      console.log('retorno el archivo', integrationFile);
    }
  }
};
